import React from "react";
import TodoList from "./TodoList";

function App() {
  return (
    <div className="app">
      <TodoList/>
    </div>
  );
}

export default App;
